import { get, post } from "@/utils/request";
import type { Recall, CommonForm, Detail } from "@/types/procss";
import type { Response } from "@/types/axios";

//step1
export const getBusinessApplyFirstInfo = (params: {
  BranchCompanyFlowId: number | string;
}): Promise<Response<Detail>> =>
  post("/api/businessApply/getBusinessApplyFirstInfo", params);

export const startBusinessApplyFirst = (params: CommonForm) =>
  post("/api/businessApply/startBusinessApplyFirst", params);

//step2
export const startBusinessApplySecond = (
  params: CommonForm
): Promise<Response<Detail>> =>
  post("/api/businessApply/startBusinessApplySecond", params);

export const getBusinessApplySecondInfo = (params: {
  BranchCompanyFlowId: number | string;
}): Promise<Response<Detail>> =>
  post("/api/businessApply/getBusinessApplySecondInfo", params);

//step3
export const getBusinessApplyThirdInfo = (params: {
  BranchCompanyFlowId: number | string;
}): Promise<Response<Detail>> =>
  post("/api/businessApply/getBusinessApplyThirdInfo", params);

export const startBusinessApplyThird = (
  params: CommonForm
): Promise<Response<Detail>> =>
  post("/api/businessApply/startBusinessApplyThird", params);

//工商备案
export const getBusinessFilingsInfo = (params: {
  BranchCompanyFlowId: number | string;
}): Promise<Response<Detail>> =>
  post("/api/businessApply/getBusinessFilingsInfo", params);

export const startBusinessFilings = (
  params: CommonForm
): Promise<Response<Detail>> =>
  post("/api/businessApply/startBusinessFilings", params);

//节点3结束
